import { LenderConfig } from "../dto/lender.dto";

export interface LenderState {
  loading: boolean;
  lenderConfig: LenderConfig | null;
}

const defaultState: LenderState = {
  loading: false,
  lenderConfig: null,
};

export default function LenderStateReducer(
  state = defaultState,
  action: any
): LenderState {
  switch (action.type) {
    case "REQUEST_GET_LENDER_CONFIG":
      return {
        ...state,
        loading: true,
      };
    case "REQUEST_GET_LENDER_CONFIG_SUCCESS":
      return {
        ...state,
        loading: false,
        lenderConfig: action.payload,
      };
    case "REQUEST_GET_LENDER_CONFIG_FAILURE":
      return {
        ...state,
        loading: false,
        lenderConfig: null,
      };
    default:
      return state;
  }
}
